// UnsubscribePage.js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { unsubscribeEmailAlert } from '../../SetupActions';

import styles from './styles.css';

const UNSUBSCRIBING = 0;
const SUCCESS = 1;
const ERROR = -1;

class EmailAlertUnsubscribePage extends Component {
  constructor(props) {
    super(props);
    this.state = { status: UNSUBSCRIBING };
  }

  componentDidMount() {
    const queryString = this.props.location.search;
    if (queryString.startsWith('?key=')) {

      const rawKey = queryString.slice(5);
      if (rawKey) {
        this.unsubscribeUser(rawKey);
      } else {
        this.setState({ status: ERROR });
      }
    } else {
      this.setState({ status: ERROR });
    }

  }

  async unsubscribeUser(key) {
    try {
      const response = (await unsubscribeEmailAlert(key) || {});
      if (response.success) {
        this.setState({ status: SUCCESS  });
      } else {
        this.setState({ status: ERROR });
      }
    } catch (error) {
      this.setState({ status: ERROR });
    }
  };

  getMessage(status) {
    switch (status) {
      case SUCCESS:
        return 'You have been successfully unsubscribed.';
      case ERROR:
        return 'An error occurred. Please try again.';
      default:
        return '';
    }
  }

  render() {
    const { status } = this.state;
    return (
      <div className={styles.unsubsribe}>
        <div className="container text-center">
          <h1 className="page-header">TruSales</h1>
          <h2 className={styles.message}>{this.getMessage(status)}</h2>
          {status === UNSUBSCRIBING && <span><Fa name="spinner" spin /></span>}
          {status === SUCCESS && <p>You will no longer receive emails from our alert service. <br/>You can modify this setting at any time within your account settings.</p>}
        </div>
      </div>
    );
  }  
}

EmailAlertUnsubscribePage.propTypes = {
  key: PropTypes.string
};

export default EmailAlertUnsubscribePage;
